import React, { PureComponent } from "react";
import { Badge } from "react-bootstrap";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import messages from "../../assets/i18n";
import { CurrencyLabel } from "../Labels";
import ItemList from "../../containers/ItemList/ItemList";

/**
 * Componente para mostrar a tabela do resultado da conciliação
 * @param {object} props.itens a ser utilizado
 * @author Otávio Bastilho
 * @copyright 10/2019
 */

class ConciliationResultTable extends PureComponent {

	render() {
		const { itens, lang } = this.props;

		const headers = [
			messages[lang].labelItem,
			messages[lang].description,
			messages[lang].EAN,
			messages[lang].qtyPO,
			messages[lang].ncmPO,
			messages[lang].costPO,
			messages[lang].itemPOTotal,
			messages[lang].qtyNF,
			messages[lang].ncmNF,
			messages[lang].costNF,
			messages[lang].itemNFTotal,
			messages[lang].statusNF,
		];

		let qtdPO       = 0
		let totalItemPO = 0
		let qtdNF       = 0
		let totalItemNF = 0

		const listTable = itens && itens.map((item, i) => {
			const status = item.qtItensPo !== item.qtItensNf || item.ncmPo !== item.ncmNf || item.valorVendaPo !== item.valorVendaNf || item.custoUnitarioPo !== item.custoUnitarioNf ? 'danger' : 'success' 

			qtdPO += item.qtItensPo ? parseInt(item.qtItensPo) : 0
			totalItemPO += item.valorVendaPo ? parseFloat(item.valorVendaPo) : 0
			qtdNF += item.qtItensNf ? parseInt(item.qtItensNf) : 0
			totalItemNF += item.valorVendaNf ? parseFloat(item.valorVendaNf) : 0

			return ([	
				item.motivoReprovacao
				?							
					{
						text: item.item && item.item.codItem,
						className: isForaDaMargem(item.motivoReprovacao) ? 'font-weight-bold' : '',
						onClick: () => {
							this.props.dispatchModalMotivoReprovacao(
								true,
								item.item && item.item.codItem,
								item.motivoReprovacao || ''
							);
						},
					}
				:
					{
						text: item.item && item.item.codItem,
						className: isForaDaMargem(item.motivoReprovacao) ? 'font-weight-bold' : ''
					}
				,
				{
					text: item.item && item.item.detalheItems[0].descricaoCurta,
					tooltip: item.item && item.item.detalheItems[0].descricaoCurta,
					className: isForaDaMargem(item.motivoReprovacao) ? 'font-weight-bold' : ''
				},
				{
					text: item.ean,
					className: isForaDaMargem(item.motivoReprovacao) ? 'font-weight-bold' : ''
				},
				{
					text: item.qtItensPo,
					className: isForaDaMargem(item.motivoReprovacao) ? 'font-weight-bold' : ''
				},
				{
					text: item.ncmPo,
					className: isForaDaMargem(item.motivoReprovacao) ? 'font-weight-bold' : ''
				},
				{
					text: item.custoUnitarioPo ? <CurrencyLabel amount={parseFloat(item.custoUnitarioPo)} locale="br" /> : '',
					className: isForaDaMargem(item.motivoReprovacao) ? 'font-weight-bold' : ''
				},
				{
					text: item.valorVendaPo ? <CurrencyLabel amount={parseFloat(item.valorVendaPo)} locale="br" /> : '',
					className: isForaDaMargem(item.motivoReprovacao) ? 'font-weight-bold' : ''
				},
				{
					text: item.qtItensNf,
					className: isForaDaMargem(item.motivoReprovacao) ? 'font-weight-bold' : ''
				},
				{
					text: item.ncmNf,
					className: isForaDaMargem(item.motivoReprovacao) ? 'font-weight-bold' : ''
				},
				{
					text: item.custoUnitarioNf ? <CurrencyLabel amount={parseFloat(item.custoUnitarioNf)} locale="br" /> : '',
					className: isForaDaMargem(item.motivoReprovacao) ? 'font-weight-bold' : ''
				},
				{
					text: item.valorVendaNf ? <CurrencyLabel amount={parseFloat(item.valorVendaNf)} locale="br" /> : '',
					className: isForaDaMargem(item.motivoReprovacao) ? 'font-weight-bold' : ''
				},
				{
					text: <Badge pill variant={status}>{messages[lang].ApprovedOrRefused[status]}</Badge>,
					className: isForaDaMargem(item.motivoReprovacao) ? 'font-weight-bold' : ''
				}
			])
		})

		return <ItemList 
					titleTable={messages[lang].tableComparationOrderInvoice}
					header={headers}
					listTable={listTable}
					somatoriasConciliacao={
						{qtdPO: qtdPO, totalItemPO: totalItemPO, qtdNF: qtdNF, totalItemNF: totalItemNF}
					} />
	}
}

function isForaDaMargem(motivoReprovacao) {
	if (!motivoReprovacao) {
		return false;
	}
	return motivoReprovacao.includes('divergência fora da margem de tolerância');
}

const mapStateToProps = state => ({
	lang: state.language.name
});

const mapDispatchToProps = dispatch => {
	return {
		dispatchModalMotivoReprovacao: (show, item, message) =>
			dispatch({
				type: "SHOW_MOTIVO_REPROVACAO_MODAL",
				show: show,
				item: item,
				message: message
			}),
	};
};

ConciliationResultTable.propTypes = {
    itens: PropTypes.array.isRequired,
};

export default connect(mapStateToProps,mapDispatchToProps)(ConciliationResultTable);